import cn from 'classnames';
import * as React from 'react';

import { FormStatusTokens } from 'styles/formStatusTokens';

import s from './StatusMark.module.scss';

type StatusMarkProps = {
  colorToken: FormStatusTokens;
  className?: string;
};

const StatusMark: React.FC<StatusMarkProps> = ({ colorToken, className }) => {
  return (
    <div
      className={cn(s.statusMark, s[`status-mark-${colorToken}`], className)}
    />
  );
};

export default React.memo(StatusMark);
